module.exports = __webpack_public_path__ + "static/img/levelComplete.dde60066.png";